import React from 'react';
import { Flex } from 'antd';
import { Image } from '@packages/utils';
import { Text, Title } from 'components/Base/Typography';
import grow404 from 'assets/images/grow_404.svg';

export interface TPageErrorStateProps {
  imgSrc?: string;
  imgWidth?: number;
  title?: string;
  message?: string;
}

const PageErrorState: React.FC<TPageErrorStateProps> = ({
  imgSrc = grow404,
  imgWidth = 300,
  title,
  message,
}) => {
  return (
    <Flex
      justify="center"
      align="center"
      vertical
      style={{ height: 'calc(100vh - 200px)', background: '#FFF' }}
    >
      <Image
        src={imgSrc}
        width={imgWidth}
        alt="Error"
        style={{ marginBottom: 24 }}
      />
      {title && (
        <Title level={3} color="#00779F" style={{ marginBottom: 8 }}>
          {title}
        </Title>
      )}
      {message && <Text>{message}</Text>}
    </Flex>
  );
};

export default PageErrorState;
